import '@material/web/dialog/dialog.js';
import { QuoteProductLine } from './models/quoting/QuoteProductLine';
import { goToQuote } from './utils/go-to-quote';

export class StartQuoteController {
    defaultLine: QuoteProductLine[] = [];
    isBundleable: boolean = false;
    bundleDialogGenerated: boolean = false;

    submitQuoteRequest = (): void => {
        if (!this.isBundleable) {
            this.goToQuotePage(this.defaultLine);
        } else {
            this.showBundleDialog();
        }
    };

    showBundleDialog = (): void => {
        const dialogEl = document.getElementById('bundleDialog') as any;
        this.bundleDialogGenerated = true;
        if (dialogEl) dialogEl.showModal ? dialogEl.showModal() : dialogEl.show();
    };

    handleFormSubmit = (event: Event): void => {
        event.preventDefault();
        this.submitQuoteRequest();
    };

    goToQuotePage = (businessLines: QuoteProductLine[]): void => {
        const agentCode = (document.querySelector(".agentCodeInput") as HTMLInputElement).value;
        if (this.bundleDialogGenerated) {
            (document.querySelector(".linear-progress") as HTMLElement).style.display = "grid";
        }
        goToQuote(businessLines, agentCode);
    };
}
